import type { I18nDict } from '../types.ts'

export const ar: I18nDict = {
  app_name: 'ZION',
  settings_title: 'الإعدادات',
  section_language: 'اللغة',
  section_identity: 'الهوية المحلية',
  section_updates: 'تحديث التطبيق',
  section_notifications: 'الإشعارات',
  section_theme: 'المظهر المرئي',
  section_backup: 'نسخ احتياطي للمحادثات',
  section_privacy_network: 'خصوصية الشبكة',
  section_media: 'الوسائط المتعددة',
  section_security: 'الأمان وكلمة المرور',
  section_exit: 'إغلاق وحذف البيانات',
  toggle_external_links: 'استقبال وعرض الروابط الخارجية',
  hint_external_links: 'إذا كان مغلقًا: لا معاينة للروابط في المحادثة ولا يمكن فتح عناوين URL الخارجية (حماية من تتبع IP).',
  toggle_auto_media: 'تنزيل الوسائط والمستندات تلقائيًا',
  hint_auto_media: 'إذا كان مغلقًا: لا تُنزَّل الصور والفيديوهات والملفات في الخلفية — اضغط يدويًا في المحادثة.',
  toggle_require_unlock: 'كلمة مرور عند فتح التطبيق',
  hint_require_unlock: 'عند التفعيل، تُطلَب كلمة المرور الرئيسية في كل مرة تفتح فيها ZION.',
  toggle_wipe_exit: 'مسح البيانات عند الخروج',
  hint_wipe_exit: 'عند التفعيل، يؤدي إغلاق التطبيق إلى مسح ذاكرة التخزين المؤقت في RAM وبيانات الجلسة.',
  btn_exit: 'خروج',
  btn_delete_all: 'حذف جميع البيانات',
  btn_lock: 'قفل التطبيق',
  btn_back: 'رجوع',
  warn_disable_password_title: '⚠️ تحذير',
  warn_disable_password_body: 'تعطيل كلمة مرور الفتح يعني أن أي شخص لديه جهازك يمكنه قراءة رسائلك المشفّرة. هل أنت متأكد أنك تريد المتابعة؟',
  warn_delete_all_1: 'هل تريد حقًا تدمير قاعدة البيانات بالكامل؟ هذا الإجراء لا رجعة فيه.',
  warn_delete_all_2: 'تأكيد نهائي: سيتم حذف جميع المحادثات والمفاتيح الخاصة والإعدادات نهائيًا.',
  link_blocked: 'تم حظر الرابط الخارجي (إعدادات الخصوصية).',
  lang_welcome_title: 'مرحبًا بك في ZION',
  lang_welcome_sub: 'اختر لغتك',
  lang_continue: 'متابعة',
  settings_language_label: 'لغة التطبيق',
  auth_unlock_title: 'إلغاء القفل',
  auth_or_password: '— أو إلغاء القفل بكلمة المرور —',
  auth_password_master: 'كلمة المرور الرئيسية',
  auth_unlock_btn: 'إلغاء القفل',
  auth_verifying: 'جارٍ التحقق…',
  auth_wrong_password: 'كلمة مرور خاطئة',
  auth_unlocked: 'تم إلغاء القفل ✓',
  auth_access_title: 'الانضمام إلى ZION',
  auth_beta_spots: 'نسخة تجريبية مجانية · المقاعد المتبقية:',
  auth_beta_full: 'النسخة التجريبية ممتلئة ({max} مستخدم). حاول مرة أخرى لاحقًا.',
  auth_beta_free: 'نسخة تجريبية مجانية · لا يلزم ترخيص',
  auth_or_create: '— أو إنشاء هوية جديدة —',
  auth_password_min: 'كلمة المرور (8 أحرف على الأقل)',
  auth_password_confirm: 'تأكيد كلمة المرور',
  auth_privacy_check: 'لقد قرأت',
  auth_privacy_link: 'سياسة الخصوصية',
  auth_terms_check: 'أوافق على',
  auth_terms_link: 'شروط الخدمة',
  auth_password_local_hint: 'كلمة المرور لا تغادر هذا الجهاز أبدًا. لا يوجد حساب على الخادم.',
  auth_create_identity: 'إنشاء هوية',
  auth_accept_legal_err: 'اقبل سياسة الخصوصية والشروط للمتابعة',
  auth_generating_keys: 'جارٍ إنشاء المفاتيح والجلسة…',
  auth_generating_identity: 'جارٍ إنشاء هوية مجهولة…',
  auth_generating_detail: 'مفاتيح ECDH · اسم مستعار · جلسة socket · رمز ZN-',
  auth_you_are: 'أنت',
  auth_daily_suffix_hint: 'تتغير اللاحقة اليومية كل يوم UTC. للإقران، استخدم رمز ZN- في الصفحة الرئيسية.',
  auth_enter: 'الدخول إلى ZION',
  auth_starting: 'جارٍ البدء…',
  auth_restore_title: 'استعادة النسخة الاحتياطية',
  auth_restore_hint: 'لديك نسخة احتياطية مشفّرة؟ استعد الهوية وجهات الاتصال والمحادثات (مثلًا بعد مسح ذاكرة التخزين المؤقت).',
  auth_restore_file: 'ملف النسخة الاحتياطية (.enc / .enc.json)',
  auth_restore_pass: 'عبارة مرور النسخة الاحتياطية',
  auth_restore_pass_ph: 'عبارة المرور المستخدمة عند التصدير',
  auth_restore_btn: 'استعادة النسخة الاحتياطية',
  auth_restore_pick_file: 'اختر ملف نسخة احتياطية (.enc أو .enc.json).',
  auth_restore_need_pass: 'أدخل عبارة المرور.',
  auth_restoring: 'جارٍ الاستعادة…',
  auth_file_prefix: 'الملف:',
  common_accept: 'قبول',
  common_reject: 'رفض',
  common_cancel: 'إلغاء',
  common_accepting: 'جارٍ القبول…',
  common_error: 'خطأ',
  common_loading: 'جارٍ التحميل…',
  common_send: 'إرسال',
  common_copied: 'تم النسخ ✓',
  common_copy_failed: 'فشل النسخ',
  common_ok: 'موافق',
  common_today: 'اليوم',
  common_yesterday: 'أمس',
  common_sending: 'جارٍ الإرسال…',
  home_zn_midnight_hint: 'يتغير عند منتصف الليل UTC (خلال {h}س {m}د)',
  home_temp_empty: 'لا توجد محادثات مؤقتة. اضغط ⏱ على جهة اتصال لبدء واحدة.',
  home_unread_aria: '{count} رسائل',
  home_temp_waiting: 'في انتظار القبول…',
  home_temp_expires: 'محادثة مؤقتة · تنتهي خلال {remaining}',
  home_temp_cancel: 'إلغاء',
  home_temp_fallback_label: 'محادثة مؤقتة',
  home_temp_invite_title: '⏱ دعوة محادثة مؤقتة',
  home_temp_invite_body: 'يريد {nick} محادثة مؤقتة ({duration}).',
  home_temp_invite_hint: 'اقبل لبدء تبادل رسائل ستختفي عند انتهاء المدة.',
  home_temp_accept: 'قبول',
  home_temp_reject: 'رفض',
  home_temp_accepting: 'جارٍ القبول…',
  home_contacts_empty: 'لا توجد جهات اتصال. شارك رمز ZN- أو QR للإقران.',
  home_temp_chat_aria: 'محادثة مؤقتة',
  home_btn_pair_title: 'إقران',
  home_btn_settings_title: 'الإعدادات',
  home_zn_title: 'رمز ZN- لليوم',
  home_btn_copy_zn: 'نسخ ZN-',
  home_btn_open_pair: 'QR الإقران',
  home_section_temp: 'محادثات مؤقتة',
  home_section_chat: 'المحادثات',
  home_loading: 'جارٍ التحميل…',
  home_pair_zn_title: 'الإقران برمز ZN-',
  home_btn_zn_pair: 'إرسال الطلب',
  home_copied: 'تم النسخ ✓',
  home_copy_failed: 'فشل النسخ',
  home_pair_request_title: 'طلب جهة اتصال',
  home_pair_request_body: 'يريد {name} المحادثة.',
  home_pair_reject: 'رفض',
  home_pair_accept: 'قبول',
  home_pair_accepting: 'جارٍ القبول…',
  home_pair_accept_failed: 'فشل القبول',
  home_zn_digits_err: 'أدخل الأرقام الخمسة بعد ZN-.',
  home_sending: 'جارٍ الإرسال…',
  chat_rename: 'إعادة تسمية',
  chat_rename_matrix: '[إعادة تسمية]',
  chat_rename_title: 'إعادة تسمية جهة الاتصال',
  chat_menu_title: 'خيارات المحادثة',
  chat_loading: 'جارٍ تحميل الرسائل…',
  chat_reply_to: 'الرد على',
  chat_cancel_title: 'إلغاء',
  chat_voice_lock_hint: 'اسحب لأعلى لقفل التسجيل',
  chat_voice_locked: 'التسجيل مقفل — اضغط تم',
  chat_voice_stop: 'تم',
  chat_voice_stop_title: 'تم',
  chat_voice_preview_label: 'معاينة صوتية — استمع قبل الإرسال',
  chat_voice_send: 'إرسال',
  chat_voice_send_title: 'إرسال',
  chat_timer_label: 'المؤقت',
  chat_timer_title: 'مؤقت الرسالة',
  chat_timer_off: 'إيقاف',
  chat_timer_15s: '15ث',
  chat_timer_30s: '30ث',
  chat_timer_1m: '1د',
  chat_timer_2m: '2د',
  chat_photo: 'صورة',
  chat_photo_title: 'صورة',
  chat_voice_hold: 'اضغط مطولًا للتسجيل',
  chat_voice_hold_title: 'اضغط مطولًا للتسجيل',
  chat_doc: 'مستند',
  chat_doc_title: 'مستند',
  chat_attach_title: 'مرفقات',
  chat_input_placeholder: 'رسالة مشفّرة E2E…',
  chat_send: 'إرسال',
  chat_rename_modal_title: 'إعادة تسمية جهة الاتصال',
  chat_rename_nickname: 'الاسم المستعار: @{nick}',
  chat_rename_placeholder: 'اسم مخصص',
  chat_rename_cancel: 'إلغاء',
  chat_rename_save: 'حفظ',
  chat_action_reply: '↩ رد',
  chat_action_copy: '⎘ نسخ',
  chat_action_delete_me: '🗑 حذف لدي',
  chat_action_delete_all: '🗑 حذف للجميع',
  chat_action_cancel: 'إلغاء',
  chat_menu_clear_me: '🗑 مسح المحادثة (لي فقط)',
  chat_menu_clear_all: '🗑 حذف المحادثة للجميع',
  chat_menu_cancel: 'إلغاء',
  chat_doc_send_title: 'إرسال مستند',
  chat_doc_default_name: 'مستند',
  chat_doc_send_hint: 'سيُضغَّط الملف ويُشفَّر E2E ويُرسَل. الحد الأقصى 5 م.ب.',
  chat_doc_cancel: 'إلغاء',
  chat_doc_send_encrypted: 'إرسال مشفّر',
  chat_doc_too_large: '⚠️ الملف كبير جدًا: الحد الأقصى الأمني للمستندات هو 5 م.ب.',
  chat_doc_unsupported: 'نوع مستند غير مدعوم.',
  chat_copy_failed: 'فشل النسخ',
  chat_confirm_delete_me: 'حذف هذه الرسالة لديك فقط؟',
  chat_confirm_delete_all: 'حذف هذه الرسالة للجميع؟',
  chat_confirm_clear_all: 'حذف المحادثة بالكامل للجميع؟ هذا الإجراء لا رجعة فيه.',
  chat_confirm_clear_me: 'مسح المحادثة لديك فقط؟',
  chat_jump_new: '↓ رسائل جديدة',
  chat_empty: 'لا توجد رسائل. اكتب شيئًا للبدء.',
  chat_voice_err_short: 'الرسالة الصوتية قصيرة جدًا (الحد الأدنى ثانية واحدة).',
  chat_voice_err_long: 'الرسالة الصوتية طويلة جدًا (الحد الأقصى دقيقتان).',
  chat_voice_err_large: 'الرسالة الصوتية كبيرة جدًا (الحد الأقصى 3 م.ب.).',
  chat_voice_err_start: 'تعذّر بدء التسجيل الصوتي.',
  chat_destroyed: '✉ تمت قراءة الرسالة وتدميرها',
  chat_destroyed_title: 'تمت قراءة الرسالة وتدميرها',
  chat_hold_options: 'اضغط مطولًا للخيارات',
  chat_reply_fallback: 'رسالة',
  chat_timer_badge: '⏱ {seconds}ث',
  chat_timer_badge_pending: '⏱ …',
  pair_zn_midnight_hint: 'يتغير رمز ZN- عند منتصف الليل UTC (خلال {h}س {m}د).',
  pair_copied: 'تم النسخ ✓',
  pair_copy_failed: 'فشل النسخ',
  pair_title: 'الإقران',
  pair_zn_title: 'رمز ZN- الخاص بك اليوم',
  pair_btn_copy_zn: 'نسخ رمز ZN-',
  pair_tab_mine: 'QR الخاص بي',
  pair_tab_scan: 'مسح / ZN-',
  pair_qr_aria: 'QR الإقران',
  pair_expires_in: 'ينتهي خلال',
  pair_btn_copy_payload: 'نسخ الحمولة',
  pair_btn_regen_qr: 'إعادة إنشاء QR',
  pair_qr_hint: 'اعرض هذا QR على الجهاز الآخر. صالح لمدة 10 دقائق — متوافق مع تطبيق Android.',
  pair_expired: 'منتهٍ',
  pair_contact_zn_title: 'رمز ZN- لجهة الاتصال',
  pair_zn_prefix_hint: 'البادئة <strong>ZN-</strong> مُعيَّنة مسبقًا — أدخل الأحرف/الأرقام الخمسة فقط.',
  pair_btn_zn_request: 'إرسال طلب ZN-',
  pair_paste_title: 'أو الصق QR من نوع ZION1::',
  pair_paste_hint: 'الصق حمولة <code>ZION1::</code> أو ارفع صورة للـ QR.',
  pair_paste_placeholder: 'ZION1::…',
  pair_btn_pick_qr: 'من صورة / كاميرا',
  pair_btn_connect_qr: 'الاتصال عبر QR',
  pair_zn_digits_err: 'أدخل الأرقام الخمسة بعد ZN-.',
  pair_sending: 'جارٍ إرسال الطلب…',
  pair_reading_qr: 'جارٍ قراءة QR…',
  pair_qr_not_found: 'لم يُعثر على رمز QR في الصورة.',
  pair_zn_read_ok: 'تمت قراءة رمز ZN- — أكّد بإرسال الطلب.',
  pair_qr_read_ok: 'تمت قراءة QR — أكّد بالاتصال عبر QR.',
  pair_qr_read_err: 'خطأ في قراءة QR.',
  settings_identity_hint: 'كلمة المرور والمفاتيح تبقى في هذا المتصفح. لا يوجد حساب على الخادم.',
  settings_btn_add_home: 'دليل الإضافة إلى الشاشة الرئيسية',
  settings_devices_title: 'الأجهزة المرتبطة',
  settings_devices_hint: 'متعدد الأجهزة Zero-Knowledge: المفاتيح تنتقل مشفّرة E2E. الخادم مجرد وسيط.',
  settings_btn_link_device: 'ربط جهاز جديد',
  settings_btn_sync_pc: 'مزامنة سجل الكمبيوتر',
  settings_no_devices: 'لا توجد أجهزة مرتبطة.',
  settings_device_self: 'هذا الجهاز',
  settings_version_prefix: 'الإصدار:',
  settings_ios_push_hint: '<strong>iPhone:</strong> الإشعارات = PWA من الشاشة الرئيسية + البanner/الصوت مفعّل. Build ≥ <code>iospush7</code>.',
  settings_btn_force_update: 'فرض تحديث التطبيق',
  settings_updating: 'جارٍ التحديث…',
  settings_push_mode_prefix: 'الوضع:',
  settings_push_hint_ios: '<strong>iPad/iPhone:</strong> الإشعارات تعمل فقط عند فتح ZION من أيقونة الشاشة الرئيسية (مشاركة → إضافة إلى الشاشة الرئيسية). في Safari العادي <em>لا</em> تتوفر — حتى على iOS 17. بعد التثبيت على الشاشة الرئيسية، عد هنا واضغط تفعيل الإشعارات.',
  settings_btn_enable_push: 'تفعيل الإشعارات الفورية',
  settings_btn_desktop_notify: 'إشعارات سطح المكتب (PC)',
  settings_btn_disable_push: 'تعطيل الإشعارات',
  settings_desktop_requesting: 'جارٍ طلب إذن سطح المكتب…',
  settings_desktop_ok: 'إشعارات سطح المكتب نشطة (صوت + نافذة منبثقة عند وصول رسالة).',
  settings_desktop_denied: 'تم رفض الإذن أو غير مدعوم.',
  settings_push_no_session: 'الجلسة غير جاهزة.',
  settings_push_requesting: 'جارٍ طلب الإذن…',
  settings_push_active: 'الإشعارات نشطة.',
  settings_push_disabled: 'الإشعارات معطّلة.',
  settings_theme_hint: 'نفس السمات كتطبيق ZION على Android.',
  settings_theme_recommended: 'موصى به',
  settings_backup_hint: 'ملف JSON مشفّر بعبارة مرور (متوافق مع تنسيق Android v2). احفظه على جهاز الكمبيوتر: جهات الاتصال والمحادثات والهوية على الويب.',
  settings_backup_pass_label: 'عبارة مرور النسخة الاحتياطية',
  settings_backup_pass_ph: 'عبارة مرور مخصصة (8 أحرف على الأقل)',
  settings_btn_export_backup: 'تصدير النسخة الاحتياطية',
  settings_backup_file_label: 'استعادة من ملف',
  settings_backup_import_pass_label: 'عبارة مرور النسخة الاحتياطية',
  settings_backup_import_pass_ph: 'عبارة المرور المستخدمة عند التصدير',
  settings_btn_import_backup: 'استعادة النسخة الاحتياطية',
  settings_backup_file_prefix: 'الملف: {name}',
  settings_backup_pass_min: 'يجب أن تكون عبارة المرور 8 أحرف على الأقل.',
  settings_backup_creating: 'جارٍ إنشاء النسخة الاحتياطية…',
  settings_backup_pick_file: 'اختر ملف نسخة احتياطية (.enc أو .enc.json).',
  settings_backup_need_pass: 'أدخل عبارة مرور النسخة الاحتياطية.',
  settings_backup_restoring: 'جارٍ الاستعادة…',
  settings_backup_overwrite_confirm: 'استبدال البيانات المحلية؟',
  settings_modal_ok: 'موافق',
  temp_duration_5m: '5 دقائق',
  temp_duration_10m: '10 دقائق',
  temp_duration_15m: '15 دقيقة',
  temp_duration_30m: '30 دقيقة',
  temp_duration_1h: 'ساعة واحدة',
  temp_duration_6h: '6 ساعات',
  temp_duration_24h: '24 ساعة',
  temp_duration_7d: '7 أيام',
  temp_remaining_expired: 'منتهٍ',
  temp_remaining_days: '{days}ي {hours}س',
  temp_remaining_hours: '{hours}س {minutes}د',
  temp_remaining_minutes: '{minutes}د',
  temp_remaining_seconds: '{seconds}ث',
  temp_screen_subtitle: 'محادثة مؤقتة · رسائل مؤقتة',
  temp_empty: 'لا توجد رسائل مؤقتة.',
  temp_empty_hint: 'اكتب رسالة مؤقتة. ستختفي عند انتهاء المؤقت.',
  temp_input_placeholder: 'رسالة مؤقتة…',
  temp_send: 'إرسال',
  temp_waiting_accept: 'في انتظار قبول {name} للمحادثة المؤقتة…',
  temp_waiting_placeholder: 'في انتظار القبول…',
  temp_expires_in: 'ينتهي خلال {remaining}',
  temp_duration_title: 'محادثة مؤقتة',
  temp_duration_with: 'مع {name}',
  temp_duration_hint: 'اختر المدة — ستختفي المحادثة من كلا الجهازين.',
  temp_sending_invite: 'جارٍ إرسال الدعوة…',
  voice_lock_hint: 'اسحب لأعلى لقفل التسجيل',
  voice_locked: 'التسجيل مقفل — اضغط تم',
  add_home_title: 'إضافة إلى الشاشة الرئيسية (iPhone / iPad)',
  add_home_guide_title: 'دليل Safari',
  add_home_step1: 'افتح <strong>Safari</strong> على هذه الصفحة (<code>zionyx.ch/app/</code>)',
  add_home_step2: 'اضغط <strong>مشاركة</strong> (مربع مع سهم لأعلى)',
  add_home_step3: 'اختر <strong>إضافة إلى الشاشة الرئيسية</strong>',
  add_home_step4: 'افتح ZION من <strong>الأيقونة</strong> — وليس من تبويب Safari',
  add_home_hint: 'على iOS/iPadOS 16.4+، يدعم تطبيق الشاشة الرئيسية إشعارات Web Push ولوحة مفاتيح المحادثة. بعد التثبيت، انتقل إلى <strong>الإعدادات → تفعيل الإشعارات</strong>.',
  add_home_btn_continue: 'فهمت — متابعة',
  add_home_btn_skip: 'تخطّ الآن',
  search_title: 'البحث برمز ZN-',
  search_label: 'رمز ZN- اليومي',
  search_placeholder: 'ZN-123456',
  search_btn: 'بحث',
  search_hint: 'أدخل رمز ZN- لجهة الاتصال. لا يوجد بحث بالاسم المستعار — الهوية محلية فقط.',
  search_format_err: 'التنسيق: ZN-123456',
  search_resolving: 'جارٍ حل الرمز…',
  search_invalid_code: 'رمز غير صالح — اطلب رمز ZN- محدّثًا (أعد فتح ZION على جهاز الطرف الآخر)',
  search_session_found: 'تم العثور على جلسة',
  search_tap_to_send: 'اضغط لإرسال الطلب',
  search_socket_not_ready: 'جلسة socket غير جاهزة',
  search_request_sent: 'تم إرسال الطلب ✓',
  search_request_failed: 'فشل الإرسال',
  license_title: 'تفعيل ترخيص الويب / iPhone',
  license_heading: 'الترخيص',
  license_heading_updated: 'شروط محدّثة',
  license_hint: 'أدخل رمز <strong>ZION-XXXX-XXXX-XXXX</strong> المُشترى من zionyx.ch. سيُربَط بهذا المتصفح (مفتاح محلي).',
  license_code_label: 'رمز الترخيص',
  license_code_placeholder: 'ZION-XXXX-XXXX-XXXX',
  license_btn_activate: 'تفعيل الترخيص',
  license_beta_hint: 'نسخة تجريبية للويب: استخدم ترخيص iPhone مخصصًا إن وُجد.',
  license_accept_legal_err: 'اقبل سياسة الخصوصية والشروط للمتابعة',
  license_need_code: 'أدخل رمز الترخيص',
  license_verifying: 'جارٍ التحقق من الترخيص…',
  license_invalid_or_used: 'ترخيص غير صالح أو مستخدم على جهاز آخر',
  license_active: 'الترخيص نشط ✓',
  license_err_not_found: 'رمز ترخيص غير صالح',
  license_err_conflict: 'الترخيص مرتبط بجهاز آخر',
  license_err_rate_limit: 'محاولات كثيرة — انتظر دقيقة',
  license_err_generic: 'خطأ في الترخيص',
  link_device_title: 'ربط جهاز جديد',
  link_device_hint: 'على <strong>الكمبيوتر</strong>، افتح الإعدادات → ربط جهاز جديد: ستظهر <strong>QR الأخضر</strong>. ثم امسحه أدناه (كاميرا أو صورة).',
  link_device_status_ready: '[جاهز]',
  link_device_upload_label: 'رفع صورة QR',
  link_device_btn_camera: 'فتح الكاميرا / المعرض',
  link_device_placeholder: 'رابط QR أو حمولة…',
  link_device_btn_send_vault: 'إرسال الخزنة المشفّرة',
  link_device_err_invalid_qr: 'QR غير صالح أو منتهٍ.',
  link_device_status_invalid: '[QR غير صالح]',
  link_device_status_sync_complete: '[اكتملت المزامنة]',
  link_device_status_transfer_failed: '[فشل النقل]',
  link_device_status_qr_detected: '[تم اكتشاف QR — جارٍ النقل...]',
  link_device_status_tap_camera: '[اضغط الزر الأخضر — كاميرا IPHONE]',
  link_device_status_use_camera_below: '[استخدم الكاميرا / المعرض أدناه]',
  link_device_status_point_camera: '[وجّه الكاميرا نحو QR الكمبيوتر...]',
  link_device_status_decoding: '[جارٍ فك ترميز QR...]',
  link_device_status_qr_not_found: '[لم يُعثر على QR]',
  link_device_status_decode_failed: '[فشل فك الترميز]',
  link_device_status_opened_from_qr: '[فُتح من QR — جارٍ البدء...]',
  link_recv_title: 'الربط من الهاتف',
  link_recv_hint_compact:
    'امسح رمز <strong>QR الأخضر</strong> هذا بالهاتف (الإعدادات → ربط جهاز جديد). يتم تشفير المخزن من طرف إلى طرف.',
  link_recv_hint_auth:
    'هل لديك ZION على الهاتف بالفعل؟ امسح رمز QR هذا بـ<strong>الكاميرا</strong> — يرتبط الكمبيوتر ويسجّل الدخول تلقائيًا.',
  link_recv_qr_alt: 'رمز QR لربط الجهاز',
  link_recv_copy_link: 'نسخ الرابط',
  link_recv_awaiting: '[في انتظار مسح الهاتف — النفق مفتوح...]',
  link_recv_failed: '[فشل الربط]',
  link_recv_tunnel_lost:
    'انقطع النفق — قد يكون المخزن لا يزال قيد النقل. حاول مسح رمز QR مرة أخرى.',
  notify_title_prefix: 'ZION — {name}',
  notify_default_body: 'رسالة مشفّرة جديدة',
  notify_temp_title_prefix: 'ZION ⏱ {name}',
  notify_temp_default_body: 'رسالة مؤقتة',
  force_update_title: '🚨 تحديث حرج إلزامي — للاستمرار في استخدام Zionyx بأمان، يجب تنزيل أحدث إصدار.',
  force_update_desc: 'العميل المُثبَّت غير متوافق مع الحد الأدنى للإصدار النشط على الخادم.',
  force_update_versions: 'المُثبَّت: v{current} · المطلوب: v{required}',
  force_update_btn: 'تحديث الآن',
}
